import type Maybe from 'graphql/tsutils/Maybe';

import GrowthEpicClient from 'bundles/epic/clients/Growth';

type CourseMaterial = {
  totalDuration?: Maybe<string>;
};
function getCourseAdjustedLearningHoursExperimentData<T extends CourseMaterial>(
  courseId: string,
  material: Maybe<T>
): Maybe<T> {
  const variant = GrowthEpicClient.get('learningHoursVariant');
  if (!material || !variant || variant === 'CONTROL') return material;

  return {
    ...material,
    totalDuration: 'PT99H',
  };
}

type SpecializationData = {
  id: string;
  totalLearningMonths?: Maybe<number>;
  learningHoursPerWeek?: Maybe<number>;
};
function getS12nAdjustedLearningHoursExperimentData<T extends SpecializationData>(data: Maybe<T>): Maybe<T> {
  const variant = GrowthEpicClient.get('learningHoursVariant');
  if (!data || !variant || variant === 'CONTROL') return data;

  return {
    ...data,
    totalLearningMonths: 99,
    learningHoursPerWeek: 99,
  };
}

export { getCourseAdjustedLearningHoursExperimentData, getS12nAdjustedLearningHoursExperimentData };
